// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account-badge-container {
    position: absolute;
    right: 1rem;
}

    .account-badge-container > .base-button {
        background-color: transparent;
    }

.account-badge {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    height: 3rem;
    width: 3rem;
    background-color: gray;
    border-radius: 50%;
    font-size: 18pt;
    font-weight: bold;
}

.account-button-content {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.account-name {
    height: fit-content;
    margin-right: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/Account/css/AccountBadge.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;AACf;;IAEI;QACI,6BAA6B;IACjC;;AAEJ;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB","sourcesContent":[".account-badge-container {\r\n    position: absolute;\r\n    right: 1rem;\r\n}\r\n\r\n    .account-badge-container > .base-button {\r\n        background-color: transparent;\r\n    }\r\n\r\n.account-badge {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n    align-content: center;\r\n    height: 3rem;\r\n    width: 3rem;\r\n    background-color: gray;\r\n    border-radius: 50%;\r\n    font-size: 18pt;\r\n    font-weight: bold;\r\n}\r\n\r\n.account-button-content {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n}\r\n\r\n.account-name {\r\n    height: fit-content;\r\n    margin-right: 0.5rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
